<div class="wrapper scrollbar">
  <pdf-viewer class="viewer" [src]="pdf" render-text="true"></pdf-viewer>
</div>
